import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import PrimaSquadraPage from "./pages/PrimaSquadraPage";
import GiovaniliPage from "./pages/GiovaniliPage";
import NewsPage from "./pages/NewsPage";
import ArticlePage from "./pages/ArticlePage";
import ContattiPage from "./pages/ContattiPage";
import OrganigrammaPage from "./pages/OrganigrammaPage";
import StoriaPage from "./pages/StoriaPage";
import SponsorsPage from "./pages/SponsorsPage";
import SafeguardingPage from "./pages/SafeguardingPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/prima-squadra" element={<PrimaSquadraPage />} />
          <Route path="/giovanili" element={<GiovaniliPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<ArticlePage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          <Route path="/organigramma" element={<OrganigrammaPage />} />
          <Route path="/storia" element={<StoriaPage />} />
          <Route path="/sponsor" element={<SponsorsPage />} />
          <Route path="/safeguarding" element={<SafeguardingPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
